import { AllowancesModalReducerState } from './types';

export const getDefaultState = (): AllowancesModalReducerState => ({
  isOpened: false,
  currentTimesheetId: '',
  allowances: [],
  formData: [],
  errors: []
});
